module.exports = __webpack_public_path__ + "static/media/GOOGLE_POLISH_FEMALE2.8588db89.mp3";